export const SandboxesOSActions = {
  SELECT_OS: 'sandboxes/SELECT_OS',
}

export const selectOS = (os) => ({
  type: SandboxesOSActions.SELECT_OS,
  os,
})
